import React from 'react';
import { getDaysUntil } from '../utils/helpers';

export default function Countdown({ date, large }) {
  const days = getDaysUntil(date);

  if (days < 0) {
    const absDays = Math.abs(days);
    return (
      <div className={`text-center ${large ? '' : ''}`}>
        <div className={`font-bold text-gray-400 ${large ? 'text-lg' : 'text-sm'}`}>
          {absDays === 1 ? 'Yesterday!' : `${absDays} days ago`}
        </div>
      </div>
    );
  }

  if (days === 0) {
    return (
      <div className="text-center">
        <div className={`font-bold text-coral-500 animate-tick ${large ? 'text-3xl' : 'text-lg'}`}>
          TODAY! 🎉
        </div>
      </div>
    );
  }

  const weeks = Math.floor(days / 7);
  const remainingDays = days % 7;

  return (
    <div className="text-center">
      <div className={`font-extrabold bg-gradient-to-r from-purple-600 to-teal-500 bg-clip-text text-transparent ${large ? 'text-5xl' : 'text-2xl'} animate-tick`}>
        {days}
      </div>
      <div className={`font-medium text-gray-500 ${large ? 'text-base' : 'text-xs'}`}>
        {days === 1 ? 'day to go!' : 'days to go!'}
      </div>
      {large && weeks > 0 && (
        <div className="text-sm text-gray-400 mt-1">
          ({weeks} week{weeks !== 1 ? 's' : ''}{remainingDays > 0 ? ` ${remainingDays} day${remainingDays !== 1 ? 's' : ''}` : ''})
        </div>
      )}
    </div>
  );
}
